/**
 * Converts the first character of the given string to uppercase and the remaining characters to lowercase.
 *
 * @param str - The input string to be converted.
 * @returns The converted string with the first character in uppercase and the rest in lowercase.
 */
export const startCase = (str: string): string => {
  return `${str?.slice(0, 1).toUpperCase()}${str?.slice(1).toLowerCase()}`;
};
